
import image1 from '../assets/images/delice/Les-délilces.webp';
import image2 from '../assets/images/delice/IMG_6124.JPG';
import image3 from '../assets/images/delice/IMG_6179.webp';
import image4 from '../assets/images/delice/Delilce2.webp';

import imgb4s1 from '../assets/images/B4S/Macbookbrutalism.png';
import imgb4s2 from '../assets/images/B4S/Free iPhone & iPad Mockup.png';



import extazHero from '../assets/images/Extaz/A49.jpg';
import extazImg1 from '../assets/images/Extaz/Extaz_Brand_Mockup_2.jpg';
import extazImg2 from '../assets/images/Extaz/cup.jpg';
import extazImg3 from '../assets/images/Extaz/Coffee_Brand_Mockup_4.jpg';

import raHero from '../assets/images/Revesargentes/HeRO.png';
import raImg1 from '../assets/images/Revesargentes/RA_Stationery_Mockup_1.jpg';
import raImg2 from '../assets/images/Revesargentes/Sans-nom-4.gif';
import raImg3 from '../assets/images/Revesargentes/Ra_Stationery_Mockup_2.jpg';
import raImg4 from '../assets/images/Revesargentes/RA_Laptop_Mockup.jpg';
import raImg5 from '../assets/images/Revesargentes/picto.png';

import samoHero from '../assets/images/realisation/e1bcd018044163.562c2dd14c0c9.jpg';
import samoImg1 from '../assets/images/realisation/c1df7b18044163.562c2dd0c3ea1.jpg';
import samoImg2 from '../assets/images/realisation/7e782018044163.562c2dd0f3477 2.jpg';
import samoImg3 from '../assets/images/realisation/1648e118044163.562c2dd1ba64e.jpg';

import bizzonHero from '../assets/images/Bizon/HeRO.png';
import bizzonImg1 from '../assets/images/Bizon/Mokebizoniphone.png';
import bizzonImg2 from '../assets/images/Bizon/PSD 1.jpg';
import bizzonImg3 from '../assets/images/Bizon/imacbizon.png';

import mswwImg1 from '../assets/images/msww/MSW MockUp – Wood.jpg';
import mswwImg2 from '../assets/images/msww/Group 1.jpg';
import mswwImg3 from '../assets/images/msww/Wood Engraved Logo Mock-Up.jpg';

import moiseImg1 from '../assets/images/Moise/4393d1195940953.6616cf800b05f.jpeg';
import moiseImg2 from '../assets/images/Moise/packaging.jpg';
import moiseImg3 from '../assets/images/Moise/index.jpg';

import joeventImg1 from '../assets/images/Joevent/OJK90P1.jpg';
import joeventImg2 from '../assets/images/Joevent/Sans titre-22 copy 2.jpg';
import joeventImg3 from '../assets/images/Joevent/visuel salon mariage Janvier.jpg';
import joeventImg4 from '../assets/images/Joevent/preview.jpeg';
import joeventImg5 from '../assets/images/Joevent/Scene 10.jpg';
import joeventImg6 from '../assets/images/Joevent/test030.jpg';



const PROJECTDETAILS = {
    2: {
        id: 1,
        title: 'Del ile s des doudou',
        description: 'Une invitation aux saveurs des Antilles\n' +
            '\n' +
            'Les Déli’le’s des Doudous est bien plus qu’une marque, c’est une célébration vivante de la richesse culinaire antillaise. À travers une gamme de boissons exotiques et de mets traditionnels, nous avons imaginé un univers qui perpétue les traditions tout en les partageant avec le monde.\n' +
            '\n' +
            'Une identité inspirée par les Antilles\n' +
            'Pour ancrer la marque dans son héritage, nous avons puisé dans les couleurs éclatantes des îles. Des tons chaleureux d’orange et de jaune qui évoquent le soleil, les épices et la générosité de la culture locale.\n' +
            '\n' +
            'Une typographie dansante et authentique\n' +
            'apporte une touche vivante et festive. Ses courbes reflètent le rythme et la joie de vivre des Antilles, capturant l’essence de la culture.\n' +
            '\n',

        description2: 'Les Déli’le’s des Doudous, c’est aussi un voyage sensoriel. Chaque produit raconte une histoire, celle d’un savoir-faire transmis de génération en génération, des recettes qui réchauffent le cœur et une invitation à découvrir la convivialité antillaise.\n' +
            '\n' +
            'À travers cette identité, Les Déli’le’s des Doudous vous transporte sous les palmiers, dans un monde où les saveurs et les traditions se rencontrent pour créer une expérience unique et inoubliable. Bienvenue dans notre univers.',
        color: '#FFD700',
        image: image2,
        credits: ['Design by Loic SUNVE'], // Crédits
        images: [
            { src:image3, fullWidth: false },
            { src:image1, fullWidth: false },
            { src:image4, fullWidth: true },
        ],
    },

    8: {

        id: 2,
        title: 'Bizon – Application pour syndics et copropriétaires',
        description: 'Bizon est une application innovante développée pour moderniser la gestion des copropriétés et offrir une solution centralisée aux syndics, copropriétaires et propriétaires multi-biens. Cette plateforme allie efficacité, transparence et simplicité, répondant aux besoins d’un secteur souvent perçu comme complexe et bureaucratique. Avec Bizon, le syndic gagne du temps en automatisant les processus et en améliorant la communication avec les copropriétaires. De leur côté, les propriétaires bénéficient d’une vision claire et centralisée de leurs biens, qu’ils en possèdent un ou plusieurs. Bizon se positionne ainsi comme un outil indispensable pour une gestion de copropriété transparente, collaborative et moderne.',
        description2: 'Avec Bizon, le syndic gagne du temps en automatisant les processus et en améliorant la communication avec les copropriétaires. De leur côté, les propriétaires bénéficient d’une vision claire et centralisée de leurs biens, qu’ils en possèdent un ou plusieurs. Bizon se positionne ainsi comme un outil indispensable pour une gestion de copropriété transparente, collaborative et moderne.',

        color: '#FFD700',
        image: bizzonHero,
        credits: ['Design by Loic SUNVE', 'UX/UI by Loic & Steevio', 'Développement & architecture by Loic SUNVE '], // Crédits
        images: [
            { src:bizzonImg1, fullWidth: false },
            { src:bizzonImg2, fullWidth: false },
            { src:bizzonImg3, fullWidth: true },
        ],
    },



    3: {
        id: 3,
        title: 'B4Star – L’accélérateur de votre influence',
        description: 'Pour B4Star, une plateforme révolutionnaire dans l’univers de l’influence digitale, j’ai travaillé sur la conception globale du design et des interfaces, en mettant l’accent sur une expérience utilisateur fluide, intuitive et engageante. Le projet vise à réinventer la relation entre marques et consommateurs en valorisant des interactions authentiques et impactantes.',
        description2: 'Héritage et promesse dans le design\n' +
            '\n' +
            'Chaque pixel, chaque élément visuel est pensé pour refléter l’héritage de B4Star : donner du sens à la consommation et valoriser les voix des consommateurs. Le design permet une communication rapide, pertinente et surtout authentique, plaçant les utilisateurs au cœur de l’influence.\n' +
            '\n' +
            'Avec B4Star, l’influence devient un outil puissant, transparent et équitable pour construire un avenir où marques et consommateurs co-créent des relations de confiance.',


        color: '#FF7F50',
        image: 'https://via.placeholder.com/800x400',
        credits: ['Ui/UX Dashboard and Application by loic', 'Ai Engin by Grey-jule', 'developement App Mobile by Loic'],
        gallery: ['https://kalunea.com/cdn/shop/files/S8a2ac00ed1d34ce5b5c35a4c477abe9ej_0141df81-b539-4bf7-a8c4-61eeb009a3d2.webp?v=1699036109&width=1000'],
        images: [
            { src:imgb4s1, fullWidth: false },
            { src:imgb4s2, fullWidth: false },
        ],
    },

    4: {
        id: 4,
        title: 'Extase Café',
        description: 'Le logo raconte une histoire : celle d’un moment d’évasion et de réconfort, où chaque tasse de café devient une parenthèse de plaisir intense. La silhouette féminine symbolise l’élégance et l’émotion, tandis que les éléments naturels, comme les baies et les feuilles de café, évoquent la richesse et l’authenticité des origines du produit. Le design joue sur des lignes fines et délicates, offrant un équilibre entre détails organiques et une esthétique épurée. La femme drapée, enveloppée dans un mouvement fluide, renforce l’idée de chaleur et de confort.',
        description2: 'Cette identité visuelle incarne une vision : offrir à chaque client bien plus qu’une tasse de café, une véritable expérience sensorielle et émotionnelle, enracinée dans la passion du produit et l’amour de la nature.',

        color: '#FF5733',
        image: extazHero,
        credits: ['Design by Loic'],
        images: [
            { src:extazImg1, fullWidth: false },
            { src:extazImg2, fullWidth: false },
            { src:extazImg3, fullWidth: true },
        ],
    },
    5: {
        id: 5,
        title: 'Identité visuelle et site web de l’association Rêves Argentés',
        description: 'Rêves Argentés est une association dédiée aux seniors, visant à enrichir leur quotidien à travers des services, des activités et un réseau solidaire. Avec son siège en Martinique, l’association souhaitait une identité visuelle et un site web modernes, chaleureux et accessibles, reflétant ses valeurs de proximité et d’ouverture.',

        description2: 'Les lettres RA, conçues sous la forme d’une signature manuscrite, reflète l\'approche humaine, personnalisée et authentique. Ce style rappelle l’importance des liens et des histoires partagées par les seniors.\n' +
            'Trapèze ouvert : L’inscription est encadrée dans un trapèze représentant une porte ouverte, symbole d’accueil, de nouvelles opportunités et de dynamisme.',

        description3: 'L’identité visuelle et le site web de Rêves Argentés incarnent la mission de l’association : offrir une porte ouverte sur un quotidien enrichissant et solidaire pour les seniors. Ce projet marque une étape importante dans la visibilité et l’impact de l’association, tant en Martinique qu’au-delà.',
        color: '#33FFBD',
        image: raHero,
        credits: ['Mission :Création de l’identité visuelle, comprenant un logo inspiré d’une signature manuscrite et un trapèze représentant une porte ouverte. Conception et développement d’un site web moderne, intuitif et accessible, optimisé pour les seniors.',
        'Gestion complète du projet, de la conceptualisation à la mise en ligne par design by Loic et steevio'],
        images: [
            { src:raImg1, fullWidth: false },
            { src:raImg2, fullWidth: false },
            { src:raImg3, fullWidth: true },
            { src:raImg5, fullWidth: false},
        ],
        images2: [
            { src:raImg4, fullWidth: false },
            { src:raImg2, fullWidth: false },
            { src:raImg3, fullWidth: true },
        ],
    },

    6: {
        id: 6,
        title: 'Identité visuelle pour Le Samovar, école de clown',
        description: 'Pour Le Samovar, une école de clown reconnue pour son approche artistique unique et ludique, j’ai conçu une identité visuelle moderne et mémorable, basée sur un design filaire. L’objectif était de capturer l’essence poétique et joyeuse du clown tout en apportant une touche de minimalisme contemporain. Le choix du design filaire s’est imposé comme une évidence : il traduit avec légèreté et fluidité les mouvements gracieux et expressifs du clown. Chaque élément graphique, des lignes sinueuses aux formes esquissées, évoque la spontanéité, le jeu et l’émotion – des valeurs centrales de l’art clownesque.',
        description2: 'Les Déli’le’s des Doudous, c’est aussi un voyage sensoriel. Chaque produit raconte une histoire, celle d’un savoir-faire transmis de génération en génération, des recettes qui réchauffent le cœur et une invitation à découvrir la convivialité antillaise.\n' +
            '\n' +
            'À travers cette identité, Les Déli’le’s des Doudous vous transporte sous les palmiers, dans un monde où les saveurs et les traditions se rencontrent pour créer une expérience unique et inoubliable. Bienvenue dans notre univers.',

        color: '#6A0DAD',
        image: samoHero,
        credits: ['Designed by Loic', 'Coded by Loic', 'Tested by Steevio'],
        images: [
            { src:samoImg1, fullWidth: false },
            { src:samoImg2, fullWidth: false },
        ],

        images2: [
            { src:samoImg3, fullWidth: true },
        ],

    },

    1: {
        id: 7,
        title: ' Identité visuelle pour MSWW, ébéniste spécialisé dans le sur-mesure',
        description: 'Le logo représente un arbre stylisé, formé par l’assemblage de rectangles pleins et en contour. Chaque rectangle symbolise un élément de mobilier, comme des étagères ou des portes, rappelant les créations cubiques et modulaires de l’atelier. Cette structure graphique traduit la maîtrise technique et la vision contemporaine de MSWW tout en faisant écho à la matière première au cœur de leur métier : le bois.',
        description2: 'Ce logo et l’identité visuelle dans son ensemble traduisent l’équilibre parfait entre tradition artisanale et design contemporain, tout en célébrant la beauté intemporelle du bois et le travail sur-mesure. MSWW est ainsi positionné comme un acteur incontournable pour des intérieurs uniques et élégants.',

        color: '#008080',
        image: mswwImg3,
        credits: ['design by loic'],
        images: [
            { src:mswwImg1, fullWidth: false },
            { src:mswwImg2, fullWidth: false },

        ],
    },
    0: {
        id: 8,
        title: 'Project 8',
        description: 'Reviving classic aesthetics for modern audiences.',
        color: '#FF4500',
        image: image2,
        credits: ['Art Direction: Mia', 'Photography: Noah', 'Styling: Olivia'],
        images: [
            { src:image3, fullWidth: false },
            { src:image1, fullWidth: false },
            { src:image4, fullWidth: true },
        ],
    },
    9: {
        id: 9,
        title: 'Project 9',
        description: 'Celebrating diversity through visual storytelling.',
        color: '#FFD700',
        image: image2,
        credits: ['Concept: Peter', 'Illustrations: Quinn', 'Copywriting: Riley'],
        images: [
            { src:image3, fullWidth: false },
            { src:image1, fullWidth: false },
            { src:image4, fullWidth: true },
        ],
    },
    10: {
        id: 10,
        title: 'Project 10',
        description: 'A bold exploration of typography in motion.',
        color: '#32CD32',
        image: image2,
        credits: ['Animation: Sophia', 'Typography: Thomas', 'Sound Design: Ursula'],
        images: [
            { src:image3, fullWidth: false },
            { src:image1, fullWidth: false },
            { src:image4, fullWidth: true },
        ],
    },
    11: {
        id: 11,
        title: 'Papa Moïse – Identité visuelle et packaging pour une marque d’épices artisanales',
        description: 'Papa Moïse est une marque familiale camerounaise spécialisée dans la production d’épices authentiques et artisanales. Pour accompagner son développement, nous avons conçu une identité visuelle qui capture l’essence de son savoir-faire traditionnel tout en assurant une modernité adaptée au marché. L’objectif était de créer un univers graphique à la fois riche et épuré, permettant une reconnaissance immédiate tout en facilitant le conditionnement local et artisanal. À travers des choix typographiques évocateurs, une palette de couleurs chaleureuses et un design de packaging fonctionnel, Papa Moïse se distingue par une image forte et accessible.',
        description2:"Le packaging a été conçu pour répondre aux besoins d’un conditionnement artisanal tout en valorisant l’authenticité des produits. Des étiquettes modulables, un design épuré et des matériaux adaptés permettent une mise en valeur optimale des épices tout en simplifiant la production locale. Cette identité visuelle harmonieuse renforce la notoriété de Papa Moïse et offre à ses produits une présentation cohérente, séduisante et facilement reconnaissable sur le marché.",
        color: '#4682B4',
        image: image2,
        credits: ['Designer: Loic sunve'],
        images: [
            { src:moiseImg1, fullWidth: false },
            { src:moiseImg2, fullWidth: false },
        ],

        images2: [
            { src:moiseImg3, fullWidth: true },
        ],
    },
    12: {
        id: 12,
        title: 'Project 12',
        description: 'Blending nature and technology in harmony.',
        color: '#9ACD32',
        image: image2,
        credits: ['Environment Design: Yasmin', '3D Models: Zach', 'Composer: Aaron'],
        images: [
            { src:image3, fullWidth: false },
            { src:image1, fullWidth: false },
            { src:image4, fullWidth: true },
        ],
    },
    13: {
        id: 13,
        title: 'Project 13',
        description: 'A sensory experience through immersive media.',
        color: '#800000',
        image: image2,
        credits: ['Media Artist: Bella', 'Interactive Dev: Caleb', 'Editor: Danielle'],
        images: [
            { src:image3, fullWidth: false },
            { src:image1, fullWidth: false },
            { src:image4, fullWidth: true },
        ],
    },
    14: {
        id: 14,
        title: "Jo Event – Identité visuelle, site web et campagnes publicitaires",
        description: "Jo Event est une agence événementielle innovante spécialisée dans la création d’expériences uniques et mémorables. Pour renforcer son image et son impact, nous avons développé une identité visuelle forte, un site web immersif et des campagnes de communication stratégiques, aussi bien en digital qu’en print. L’objectif était de traduire l’univers dynamique et créatif de l’agence à travers un branding distinctif, un site intuitif et des supports publicitaires percutants. Grâce à cette approche globale, Jo Event bénéficie d’une visibilité optimisée et d’une communication cohérente sur tous les canaux.",
        description2: 'L’identité visuelle a été pensée pour capturer l’essence de l’événementiel : modernité, élégance et énergie. Le site web, conçu pour une navigation fluide et immersive, met en avant les réalisations de l’agence tout en facilitant la prise de contact. Les campagnes publicitaires, déclinées en digital et en print, assurent une présence forte et engageante auprès du public cible. Cette synergie entre branding, web et communication offre à Jo Event les outils essentiels pour se démarquer et séduire ses futurs clients.',
        color: '#FF69B4',
        image: joeventImg2,
        credits: ['Team Lead: Loic SUNVE', 'Graphic Design: Loic SUNVE', 'Research: Loic SUNVE'],
        images: [
            { src:joeventImg1, fullWidth: false },
            { src:joeventImg5, fullWidth: false },
        ],

        images2: [
            { src:joeventImg3, fullWidth: false },
            { src:joeventImg4, fullWidth: false },
            { src:joeventImg6, fullWidth: true },
        ],
    },
    15: {
        id: 15,
        title: 'Project 15',
        description: 'Reimagining urban spaces through creative thinking.',
        color: '#00CED1',
        image: image2,
        credits: ['Urban Planner: Hannah', 'Architect: Isaac', 'Photographer: Julia'],
        images: [
            { src:image3, fullWidth: false },
            { src:image1, fullWidth: false },
            { src:image4, fullWidth: true },
        ],
    },


};

export default PROJECTDETAILS
